window.HumanResourceActionsAPI = new function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    _protected.setApiUrl(publicConfiguration['HumanResourceActionsServer']);

    self.getTemplates = function (brandId, param) {
        if (!brandId) {
            throw "No brand id";
        }

        var defer = $q.defer();
        _protected.request('brands/' + brandId + '/templates', 'GET', param)
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getUserActions = function (brandId ,userId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        if (!userId) {
            throw "No user id";
        }
        _protected.request('brands/' + brandId + '/users/' + userId + '/actions', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data.actions);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.getHrAuditTrail = function (brandId, actionId) {

        if (!brandId) {
            throw "No brand id";
        }
        if (!actionId) {
            throw "No action id";
        }

        var defer = $q.defer();
        _protected.request('brands/' + brandId + '/actions/' + actionId + '/audit_trail', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

};
HumanResourceActionsAPI.HR_AUDIT_TRAIL_ACTIONS = [
    {
        code: 'HR_ACTION_ISSUED',
        label: $filter('translate')("Issued Hr")
    },
    {
        code: 'HR_ACTION_SIGNED',
        label: $filter('translate')("Signed Hr")
    },
    {
        code: 'HR_ACTION_ACKNOWLEDGED',
        label: $filter('translate')("Acknowledged Hr")
    },
    {
        code: 'HR_ACTION_REJECTED',
        label: $filter('translate')("Rejected Hr")
    },
    {
        code: 'HR_ACTION_APPROVED',
        label: $filter('translate')("Approved Hr")
    },
    {
        code: 'HR_ACTION_PENDING_APPROVAL',
        label: $filter('translate')("Submitted for approval")
    },
    {
        code: 'HR_ACTION_DRAFTED',
        label: $filter('translate')("Drafted")
    },
    {
        code: 'HR_ACTION_UPDATED',
        label: $filter('translate')("Edited")
    }
];

